import { encodeURL } from '~/utils/helper/cyoHelper.js';


function getMinMaxApiPath( data, vuex ){
    const router = useRouter()
    const config = useRuntimeConfig()


    let url = config.public.baseURL
    // let url = 'abcd'

    // console.log('url', url)
    const static_url = process.env.jsonPath

    if (data.moduleType === 'cyo') {

        if ( data.page == 'setting') {
            
            return  useCountryPath('/config/setting/filters/min-max?Category=' + data.moduleSubType)
        }  

        if( data.page == 'diamond' && data.moduleSubType == 'earring' ){

            return useCountryPath('/diamond/loose-pair/filter/min-max')
        }

        if( data.page == 'diamond' ){

            return useCountryPath('/diamond/filter/min-max')
        }

    }
   
    else if (data.moduleType === 'preset') {
       
        return useCountryPath('/config/setting/filters/min-max?Category=' + data.moduleSubType)
       

    }

    else if (data.moduleType === 'shop') {
        const start_with = router.currentRoute.value.params?.start_with

        if(start_with && ['gifts-under-1000', 'gifts-under-2000', 'gifts-under-3000','gifts-under-50000','gifts-under-80000','gifts-under-100000'].includes(start_with)){
            return useCountryPath('/config/shop/filters/min-max?sub_type='+data.moduleSubType+'&gift='+start_with)

        }
        return useCountryPath('/config/shop/filters/min-max?sub_type='+data.moduleSubType)
       

    }
   
    else if (data.moduleType === 'gift_card') {
       
        return useCountryPath('gift_min_max.json?sub_type='+data.moduleSubType)
       

    }


    else if (data.moduleType === 'loose') {

        if (data.moduleSubType === 'loose') {

            return useCountryPath('/diamond/filter/min-max')
        }
    }
   
    return url

}


function getProductListApiPath( data ){

    const config = useRuntimeConfig()


    let url = config.public.baseURL

    if(data.moduleType === 'cyo'){

        if (data.pageType === 'setting') {

            return useCountryPath('/config/setting/list')
        }
        
        if (data.pageType === 'diamond' && data.moduleSubType === 'earring') {

            return useCountryPath('/diamond/loose-pair/filter')
        }

        if (data.pageType === 'diamond') {

            return useCountryPath('/diamond/filter/loose')
        }
    }
    
    if (data.moduleType === 'preset') {

        return useCountryPath('/config/setting/list')
       
    }

    if (data.moduleType === 'shop') {

        return useCountryPath('/config/shop/list/')
       
    }

    if (data.moduleType === 'gift_card') {

        return useCountryPath('/simple/list/')
       
    }


    if (data.moduleType === 'loose') {

        if (data.moduleSubType === 'loose') {

            return useCountryPath('/diamond/filter/loose')
        }
    }

    return url
}


export default function cyoApiService(){

    function getMinMax( {moduleType, moduleSubType, filters, page } ){


        const path = getMinMaxApiPath({ moduleType, moduleSubType, filters, page })
        return path
    }




    function requestProductListApi( config, payload ) {

        
        // try {
            // let token = {}

            // if( import.meta.client )  {

            //     if(axiosSource){

            //         axiosSource.cancel('FD_Operation_canceled_by_the_user')
            //     }
        
            //     axiosSource = vuexContext.$axios.CancelToken.source();

            //     token = {cancelToken: axiosSource.token}
            // }

            const url = getProductListApiPath( config ) +'?'+ encodeURL( payload )
            return url
        
        
            // const data = await $fetch( getProductListApiPath( config ) +'?'+ encodeURL( payload )) 

            const { data:receivedData, error } =  useFetch( getProductListApiPath( config ) +'?'+ encodeURL( payload ) )

            // console.log('data useAsyncData', receivedData.value)
            return receivedData.value

            // if (!res?.data) {

            //     throw vuexContext.app.context.error(  { message :'missing data property in response', status : 500}  )
            // }

            // if(import.meta.client){
                
            //     axiosSource = null;

            // }

            return data
            
        // } catch (error) {

        //     if( error.request ){
                
        //         return {error:'client_network_error'}
        //     }
        //     throw error
        // }
        
        
    }



    return {
        getMinMax,
        requestProductListApi
    };
}
